import { buildSelector } from 'shared/lib/store';

export const [useUserAuthData, getUserAuthData] = buildSelector(
    (state) => state.user.authData
);

export const [useUserInited, getUserInited] = buildSelector(
    (state) => state.user._inited
);
